var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.5C11.7368 4.5 12.1357 4.66502 12.4863 5.01562C12.8366 5.3661 13.0006 5.76382 13 6.24902V23.75C13 24.2372 12.8353 24.6358 12.4854 24.9863C12.1362 25.3361 11.7385 25.5006 11.251 25.5H6.25C5.76297 25.5 5.36504 25.3356 5.01562 24.9863C4.70967 24.6804 4.54453 24.3364 4.50781 23.9277L4.5 23.749V6.25C4.5 5.76323 4.66448 5.36522 5.01465 5.01562C5.32164 4.70915 5.66539 4.5446 6.07227 4.50781L6.25098 4.5H11.25ZM23.75 15.75C24.2368 15.75 24.6357 15.915 24.9863 16.2656C25.3366 16.6161 25.5006 17.0138 25.5 17.499V23.75C25.5 24.2372 25.3353 24.6358 24.9854 24.9863C24.6362 25.3361 24.2385 25.5006 23.751 25.5H18.75C18.263 25.5 17.865 25.3356 17.5156 24.9863C17.2097 24.6804 17.0445 24.3364 17.0078 23.9277L17 23.749V17.5C17 17.0132 17.1645 16.6152 17.5146 16.2656C17.8216 15.9592 18.1654 15.7946 18.5723 15.7578L18.751 15.75H23.75ZM23.75 4.5C24.2368 4.5 24.6357 4.66502 24.9863 5.01562C25.3366 5.3661 25.5006 5.76382 25.5 6.24902V10C25.5 10.4872 25.3353 10.8858 24.9854 11.2363C24.6362 11.5861 24.2385 11.7506 23.751 11.75H18.75C18.263 11.75 17.865 11.5856 17.5156 11.2363C17.2097 10.9304 17.0445 10.5864 17.0078 10.1777L17 9.99902V6.25C17 5.76324 17.1645 5.36522 17.5146 5.01562C17.8216 4.70916 18.1654 4.5446 18.5723 4.50781L18.751 4.5H23.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.53f0684bf92951ba17413e5576c25525.svg";
export { ForwardRef as ReactComponent };